export default __webpack_public_path__ + "static/media/blog3.88eadcc7.jpg";